"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var StructuredData =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StructuredData, _React$Component);

  function StructuredData() {
    _classCallCheck(this, StructuredData);

    return _possibleConstructorReturn(this, _getPrototypeOf(StructuredData).apply(this, arguments));
  }

  _createClass(StructuredData, [{
    key: "render",
    value: function render() {
      var structuredData = {
        '@context': 'http://schema.org',
        '@type': this.props.type
      };
      Object.assign(structuredData, this.props.data);
      var scriptTag = "<script type=\"application/ld+json\">".concat(JSON.stringify(structuredData), "</script>");
      return _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: scriptTag
        }
      });
    }
  }]);

  return StructuredData;
}(_react.default.Component);

StructuredData.propTypes = {
  type: _propTypes.default.string
};
var _default = StructuredData;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-structured-data/dist/index.js
// module id = 935
// module chunks = 0